"use client";
import { __rest } from '../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { useState } from 'react';

const Image = (_a) => {
    var { src, alt: altName, fallbackSrc, renderImageElement } = _a, rest = __rest(_a, ["src", "alt", "fallbackSrc", "renderImageElement"]);
    const [hasError, setHasError] = useState(false);
    const handleError = () => {
        if (fallbackSrc) {
            setHasError(true);
        }
    };
    const renderImage = (imagesrc) => {
        const props = Object.assign({ src: imagesrc }, rest);
        if (renderImageElement !== null &&
            typeof renderImageElement === 'function') {
            return renderImageElement(Object.assign(Object.assign(Object.assign({}, props), (fallbackSrc ? { fallbackSrc } : {})), { alt: altName }));
        }
        return jsx("img", Object.assign({}, props, { alt: altName, onError: handleError }));
    };
    return hasError ? renderImage(fallbackSrc) : renderImage(src);
};

export { Image as default };
